import LoadingComponentOverlay from "components/LoadingComponentOverlay";
import { useRfiData } from "hooks/queries";
import { GetRfiDataOptions } from "types/RfiTypes";
import MyRfiTile from "./MyRFIs";

const options: GetRfiDataOptions = {
  countOnly: true,
  includeElements: false,
  activeRfis: false,
  myRfis: true,
  includeMappedTo: false,
};

const RfiRepositoryTile = () => {
  // Hooks
  const { isLoading, data } = useRfiData(0, 1, null, null, options);
  const { isLoading: isTotalLoading, data: totalData } = useRfiData(
    0,
    1,
    null,
    null,
    { ...options, myRfis: false }
  );

  // Render
  if (isLoading || isTotalLoading)
    return (
      <>
        <LoadingComponentOverlay active={isLoading || isTotalLoading}>
          <h1 className="h3">RFI Repository</h1>
          <div className="d-flex justify-content-around mt-3">
            <MyRfiTile
              count={0}
              label={"My RFIs"}
              buttonLabel={"My RFIs"}
              navigateTo="/rfilist?myRfis=true"
            />
            <MyRfiTile
              count={0}
              label={"Total RFIs"}
              buttonLabel={"All RFIs"}
              navigateTo="/rfilist"
              outline={true}
            />
          </div>
        </LoadingComponentOverlay>
      </>
    );

  return (
    <>
      <h1 className="h3">RFI Repository</h1>
      <div className="d-flex justify-content-around mt-3">
        <MyRfiTile
          count={data?.total}
          label={"My RFIs"}
          buttonLabel={"My RFIs"}
          navigateTo="/rfilist?myRfis=true"
        />
        <MyRfiTile
          count={totalData?.total}
          label={"Total RFIs"}
          buttonLabel={"All RFIs"}
          navigateTo="/rfilist"
          outline={true}
        />
      </div>
    </>
  );
};

export default RfiRepositoryTile;
